import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {Document} from '../../model/document.model';

@Component({
    selector: 'app-download-file',
    templateUrl: './download-file.component.html',
    styleUrls: ['./download-file.component.css'],
})
export class DownloadFileComponent {
    @Input()
    receivedFile: Document;

    @ViewChild('file') file: ElementRef;

    public download(receivedFile: Document) {
        window.open(receivedFile.source, '_self');

        //download from mobile app
        let message = {
            action: "download_file",
            url: receivedFile.source
        }
        let webkit = (window as any).webkit;
        if (webkit) {
            webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(message));
        }
    }
}
